import React from "react";
import { Button } from "react-bootstrap";

const DownloadCSV = ({ data, fileName, children, ...props }) => {
  const toRowArray = (objArray) => {
    if (Array.isArray(objArray)) return objArray;
    if (typeof objArray === "string") {
      try {
        return JSON.parse(objArray);
      } catch {
        return [];
      }
    }
    return [];
  };

  const convertToCSV = (objArray) => {
    const array = toRowArray(objArray);
    let str = "";

    for (let i = 0; i < array.length; i++) {
      str += array[i] + "\r\n";
    }
    return str;
  };

  const removeDuplicates = (arr) => {
    const list = toRowArray(arr);
    return list.reduce(function (acc, curr) {
      if (!acc.includes(curr)) acc.push(curr);
      return acc;
    }, []);
  };

  const downloadCSV = () => {
    const csvData = new Blob([convertToCSV(removeDuplicates(data))], { type: "text/csv" });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement("a");
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(csvURL);
  };

  return (
    <Button onClick={downloadCSV} {...props}>
      {children}
    </Button>
  );
};

export default DownloadCSV;
